/**
 * AppUnavailable — shown when the restaurant's subscription doesn't include the customer app
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

function AppUnavailable() {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 'var(--space-lg)',
        textAlign: 'center',
        background: 'var(--bg-primary)',
        color: 'var(--text-primary)',
      }}
    >
      <span
        className="material-icons"
        style={{ fontSize: '64px', color: 'var(--text-tertiary)', marginBottom: '16px' }}
        aria-hidden="true"
      >
        block
      </span>
      <h1 style={{ fontSize: 'var(--text-xl)', margin: '0 0 8px 0' }}>
        {t('common.appUnavailable')}
      </h1>
      <p style={{ fontSize: 'var(--text-base)', color: 'var(--text-secondary)', margin: 0 }}>
        {t('common.appUnavailableMessage')}
      </p>
    </div>
  );
}

export default AppUnavailable;
